"use client";
import { usePickSlip } from "@/components/pick/create-pick";
import Button from "@/components/primitives/button";
import { SubscriptionPackage } from "@/utils/subscription";
import { BettorBasic, CapperProfileModel } from "common/dist/bettor";

export default function JoinButton({
  subscriptionPackages,
  capperHandle,
  capperProfile,
}: {
  subscriptionPackages: SubscriptionPackage[];
  capperHandle: string;
  capperProfile?: CapperProfileModel;
}) {
  const slip = usePickSlip();

  // Find the primary package, fallback to first package
  const primaryPackage = capperProfile?.primary_plan
    ? subscriptionPackages.find((pkg) => pkg.id === capperProfile.primary_plan)
    : subscriptionPackages[0];

  if (!primaryPackage) {
    return null;
  }

  // Get the default price (first active price)
  const defaultPrice =
    primaryPackage.prices?.find((p) => p.status === "active") ||
    primaryPackage.prices?.[0];

  if (!defaultPrice) {
    return null;
  }

  const formatInterval = (interval: string, count: number = 1) => {
    const intervalMap = {
      day: count === 1 ? "day" : "days",
      week: count === 1 ? "week" : "weeks",
      month: count === 1 ? "month" : "months",
      year: count === 1 ? "year" : "years",
    };

    return count === 1
      ? intervalMap[interval as keyof typeof intervalMap]
      : `${count} ${intervalMap[interval as keyof typeof intervalMap]}`;
  };

  const priceText = `$${(defaultPrice.amount_cents / 100).toFixed(
    2
  )}/${formatInterval(defaultPrice.interval, defaultPrice.interval_count)}`;

  return (
    <Button
      size="sm"
      className="!justify-center"
      onClick={async () => {
        await slip.triggerSubscriptionCheckoutByIds(
          primaryPackage.id,
          capperHandle
        );
      }}
    >
      Join for {priceText}
    </Button>
  );
}
